<span class="flex w-fit items-center rounded bg-white">
  <span
    class="ag1-badge--small"
    [class]="
      getVariantConfig()?.badgeClass
        ? $safeNavigationMigration(getVariantConfig()?.badgeClass)
        : colorClassOverride
          ? colorClassOverride
          : 'ag1-badge-' + color
    "
  >
    <div class="flex items-center">
      @if (getVariantConfig()?.leadingIcon || leadingIcon) {
        <svg-icon
          [class]="getVariantConfig()?.iconClass || ''"
          [src]="leadingIcon || getVariantConfig()?.leadingIcon"
          [svgClass]="'!h-4 !w-4 !pl-0.5'"
        />
      }

      <span class="px-1">{{ label }}</span>

      @if (getVariantConfig()?.trailingIcon || trailingIcon) {
        <svg-icon
          [class]="getVariantConfig()?.iconClass || ''"
          [src]="trailingIcon || getVariantConfig()?.trailingIcon"
          [svgClass]="'!h-4 !w-4 !pr-0.5'"
        />
      }
    </div>
  </span>
</span>
